<div class="table-container">
  @if (data) {
    @if (data.data.length) {
      <p-table [value]="data.data" [scrollable]="true" class="p-datatable-striped">
        <ng-template pTemplate="header">
          <tr>
            <th>COD.</th>
            <th>TÍTULO</th>
            <th>DATA ABERTURA</th>
            <th>ÚLTIMA ATUALIZAÇÃO</th>
            <th>STATUS</th>
            <th>MAIS INFO</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-support>
          <tr>
            <td>{{ support.id }}</td>
            <td>{{ support.title }}</td>
            <td>{{ support.created_at | date: "short" }}</td>
            <td>{{ support.updated_at | date: "short" }}</td>
            <td>
              <span class="support-table__status support-table__status--{{ support.status }}">
                {{ support.status | supportStatus }}
              </span>
            </td>
            <td>
              <button mat-icon-button aria-label="Ver detalhes" (click)="viewDetailsClick.emit(support)">
                <mat-icon>visibility</mat-icon>
              </button>
            </td>
          </tr>
        </ng-template>
      </p-table>

      <p-paginator
        (onPageChange)="pageChange.emit($event)"
        [first]="first"
        [rows]="rows"
        [totalRecords]="data.meta.total_count || 0"
        [showCurrentPageReport]="false"
        [showPageLinks]="false"
        [showJumpToPageDropdown]="false"
        [rowsPerPageOptions]="[10, 20, 30]"
        currentPageReportTemplate="Mostrando {first} até {last} de {totalRecords}" />
    } @else {
      <div class="support-table__empty">
        <i class="pi pi-inbox"></i>
        @if (filtered) {
          <p>Nenhum chamado encontrado para os filtros aplicados.</p>
        } @else {
          <p>Você ainda não abriu nenhum chamado.</p>
        }
      </div>
    }

    @if (loading) {
      <div class="support-table__loading" aria-live="polite" aria-busy="true">
        <p-progressSpinner [style]="{ width: '48px', height: '48px' }" strokeWidth="4" ariaLabel="Carregando" />
      </div>
    }
  } @else {
    <p-skeleton height="350px" />
  }
</div>
